import CartActions, { cartActionTypes } from '@Actions/cartActions';
import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import CartServices from '@Services/cartServices';

/**
 * @param action
 */
function* _getCart(action) {
  try {
    yield put(CartActions.getCartLoading(true));
    const cart = yield CartServices.getCart(action?.tenantId);
    yield put(CartActions.getCartSuccess(cart));
    if (action.callback) {
      action.callback();
    }
    yield put(CartActions.getCartLoading(false));
  } catch (error) {
    yield put(CartActions.getCartLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cartActionTypes.GET_CART.ERROR, error));
  }
}

/**
 *
 */
function* getCart() {
  yield takeLatest(cartActionTypes.GET_CART.REQUEST, _getCart);
}

/**
 * @param action
 */
function* _addToCart(action) {
  try {
    yield put(CartActions.addToCartLoading(true));
    const cart = yield CartServices.addToCart(action.payload, action?.tenantId);
    if (cart.success) {
      if (action.callback) {
        action.callback(cart);
      }
    } else {
      notification.open({
        type: 'error',
        message: cart.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CartActions.addToCartLoading(false));
  } catch (error) {
    yield put(CartActions.addToCartLoading(false));
    yield put(TrackerActions.trackAction(cartActionTypes.ADD_TO_CART.ERROR, error));
  }
}

/**
 *
 */
function* addToCart() {
  yield takeLatest(cartActionTypes.ADD_TO_CART.REQUEST, _addToCart);
}

function* _getSKUAvailability(action) {
  try {
    yield put(CartActions.getSKUAvailabilityLoading(true));
    const { payload, callback } = action;
    const skuLines = yield CartServices.getSKUAvailability(payload?.tenantId, payload?.productSkuIds);
    if (skuLines?.success) {
      yield put(CartActions.getSKUAvailabilitySuccess(skuLines?.data));
      if (callback) {
        callback(skuLines?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: skuLines.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CartActions.getSKUAvailabilityLoading(false));
  } catch (error) {
    yield put(CartActions.getSKUAvailabilityLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cartActionTypes.GET_SKU_AVAILABILITY.ERROR, error));
  }
}

function* getSKUAvailability() {
  yield takeLatest(cartActionTypes.GET_SKU_AVAILABILITY.REQUEST, _getSKUAvailability);
}

/**
 *
 */
export default function* addressSaga() {
  yield all([
    getCart(),
    addToCart(),
    getSKUAvailability(),
  ]);
}
